import requestFormComponent from './requestForm.component';
import requestFormService from './requestForm.service';
import requestFormTitle from './requestFormTitle/requestFormTitle';
import requestFormSicknessPanel from './requestFormSicknessPanel/requestFormSicknessPanel';
import requestFormSickLeaveReports from './requestFormSickLeaveReports/requestFormSickLeaveReports';

let requestFormModule = angular.module('vacations-absences.requestForm', [
  requestFormTitle,
  requestFormSicknessPanel,
  requestFormSickLeaveReports
])

  .component('requestForm', requestFormComponent)

  .service('requestFormService', requestFormService)

  .name;

export default requestFormModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/requestForm/requestForm.js